import { Account } from "common/types";
import { create } from "zustand";

export type AccountStore = {
  account: Account | null;
  setAccount: (account: Account) => Account;
  resetAccount(): void;
};

export const useAccountStore = create<AccountStore>(
  (set, get): AccountStore => ({
    account: null,
    setAccount: (account: Account) => {
      set({ account });
      return get().account;
    },
    resetAccount: () => set({ account: null }),
  }),
);
